import { MailOutlined } from '@ant-design/icons';
import { ProductSupplierDoc, ProductSupplierPurchaseOrderDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, Popconfirm, notification } from 'antd';
import { useState } from 'react';
import { sendNo } from 'src/constants';

import { errorObjectToString } from 'src/utils/common';
import { callSendMobileMessage } from 'src/utils/firebase/firebase-callable';
import { addMobileMessageSendRequestForPurchaseOrder } from 'src/utils/firebase/firebase-short-cut';
import { MessageWrapper, PurchaseOrderWithProductSupplier } from 'src/utils/supplier-purchase-order-util';

interface AgCellSendPurchaseOrderSmsProps
  extends ICellRendererParams<
    PurchaseOrderWithProductSupplier,
    any,
    {
      messageWrapper: MessageWrapper;
    }
  > {
  purchaseOrder: ProductSupplierPurchaseOrderDoc;
  productSupplier: ProductSupplierDoc;
}

export const AgCellSendPurchaseOrderSms = (params: AgCellSendPurchaseOrderSmsProps) => {
  const [loading, setLoading] = useState(false);
  const { purchaseOrder, productSupplier } = params;
  const { messagePrefix, messageSuffix, purchaseOrderInquiryNumber } = params.context.messageWrapper;
  const recipientList =
    productSupplier.additionalContacts.length > 0
      ? [productSupplier.primaryContact, ...productSupplier.additionalContacts.map((contact) => contact.number)]
      : [productSupplier.primaryContact];

  const onSendPurchaseOrder = async () => {
    setLoading(true);
    try {
      const message =
        messagePrefix +
        purchaseOrder.messageBody +
        messageSuffix +
        `\n내용문의는 ${purchaseOrderInquiryNumber}으로 연락주세요.`;

      const result = await callSendMobileMessage({
        body: message,
        sendNo,
        recipientList: recipientList.map((tel) => ({
          recipientNo: tel.replace(/-/g, ''),
          recipientGroupingKey: productSupplier.name,
        })),
      });
      if (result.data.reason) {
        throw new Error(result.data.reason);
      }
      // 문자 발송 결과가 성공한 경우 발송 요청을 추가한다.
      if (result.data.mobileMessageDocId) {
        await addMobileMessageSendRequestForPurchaseOrder(purchaseOrder._id, result.data.mobileMessageDocId);
      }
    } catch (error) {
      console.error(error);
      const description = errorObjectToString(error);
      notification.error({
        message: '발송에 실패했습니다.',
        description,
      });
    }
    setLoading(false);
  };

  return (
    <Popconfirm
      title={'문자를 발송합니다.'}
      description={`번호: ${recipientList.join(', ')}`}
      onConfirm={onSendPurchaseOrder}
      okButtonProps={{
        disabled: recipientList.length === 0,
        loading,
      }}
      cancelButtonProps={{
        loading,
      }}>
      <Button icon={<MailOutlined />} />
    </Popconfirm>
  );
};
